import { render, staticRenderFns } from "./AppLugItem.vue?vue&type=template&id=22385a32&scoped=true&"
import script from "./AppLugItem.vue?vue&type=script&lang=js&"
export * from "./AppLugItem.vue?vue&type=script&lang=js&"
import style0 from "./AppLugItem.vue?vue&type=style&index=0&id=22385a32&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22385a32",
  null
  
)

export default component.exports